import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import colors from '../../../../../tailwind.colors';
import Accordion from '../../../atoms/accordion/Accordion';
import { ArrowFull } from '../../../../../static/icons/arrowFull';
import { Loader } from '../../../atoms/loader/Loader';

const SelectCategoryContent = ({
  categories,
  onSelectCategory,
  expandedSearchResult = false,
}) => {
  if (!categories) {
    return <Loader centered />;
  }
  return (
    <div className="flex flex-1 w-full h-auto relative px-4">
      <Stack className="w-full">
        <Stack className="px-4">
          {Object.entries(categories).map(
            ([topCategoryName, categoriesData]) => (
              <Accordion
                key={topCategoryName}
                title={topCategoryName}
                description={`${categoriesData.length} st`}
                iconColor={colors.primary[500]}
                className="border-customGray-300"
                open={expandedSearchResult}
              >
                {categoriesData.map((category) => (
                  <button
                    key={category.dbName}
                    type="button"
                    aria-label={category.name}
                    onClick={() => onSelectCategory(category.dbName)}
                    className="h-16 flex categorys-center justify-between border-t border-customGray-300 global-hover pl-5 items-center"
                  >
                    <Typography>{category.name}</Typography>
                    <ArrowFull color={colors.primary[500]} direction="right" />
                  </button>
                ))}
              </Accordion>
            )
          )}
        </Stack>
      </Stack>
    </div>
  );
};

export default SelectCategoryContent;
